export default {"src":"/_next/static/media/polis.88598a37.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};